export default function mapVideos(cmsData, appData) {
	if (!appData?.pages?.boltWatchMore) return null;

	const videosData = cmsData?.pages?.videos;
	if (!videosData?.active) return null;
	
	const videosList = cmsData?.trailers;
	const moreThanThreeVideos = videosList && Object.keys(videosList).length > 3;
	
	return {
		data: {
			showViewAll: moreThanThreeVideos,
		}
	};
}